import ApiService from '../common/api.service'

class MetricsService extends ApiService {

  /**
   * start page time
   */
  startPageLoadTime () {
    this.startDate = new Date()
    this.$log.debug('Start date: ' + this.startDate)
  }

  /**
   * end page time and send data
   * @param status
   */
  endPageLoadTime (status) {
    let endDate = new Date()
    this.$log.debug('End date: ' + endDate)
    if (this.startDate) {
      let loginCompletedTime = endDate.getTime() - this.startDate.getTime()
      this.$log.debug('loginCompletedTime: ' + loginCompletedTime)
      return this.postLoginCompletedTime(loginCompletedTime, status).then(() => {
        delete this.startDate
      })
    } else {
      this.$log.warn('Error in endPageLoadTime: start date undefined')
      return Promise.resolve()
    }
  }

  /**
   * Post Login completed time and status.
   * @param time
   * @param status
   * @returns {*|any|Promise.<TResult>}
   */
  postLoginCompletedTime (time, status) {
    this.$log.debug('Post Login completed time and status', time)
    return this.post(`/metrics/login/completed`, {'time': time, 'status': status}, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((res) => {
      this.$log.info('Post Login metrics completed', res.data)
      return Promise.resolve(res.data)
    })
  }
}

export default MetricsService



// WEBPACK FOOTER //
// ./src/app/services/metrics/metrics.service.js